<template>
  <div>
    <el-form
      ref="form"
      :model="filters"
      :rules="rules"
      size="small"
    >
      <el-form-item
        label="Accounts"
        prop="accounts"
      >
        <el-select
          v-model="filters.accounts"
          multiple
          filterable
          remote
          value-key="id"
          placeholder="Account name"
          class="w-100"
          :remote-method="remoteMethodAccount"
          :loading="isLoadingAccounts"
        >
          <el-option
            v-for="item in accounts"
            :key="item.id"
            :label="item.name"
            :value="item"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="Carriers"
        prop="carriers"
      >
        <el-select
          v-model="filters.carriers"
          multiple
          filterable
          remote
          value-key="id"
          placeholder="Carrier name"
          class="w-100"
          :remote-method="remoteMethodCarrier"
          :loading="isLoadingCarriers"
        >
          <el-option
            v-for="item in carriers"
            :key="item.id"
            :label="item.name"
            :value="item"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="Send To"
        prop="sendTo"
      >
        <el-checkbox-group v-model="filters.sendTo">
          <el-checkbox
            label="Users"
            name="sendTo"
          />
          <el-checkbox
            label="Billing Contacts"
            name="sendTo"
          />
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col style="text-align: right;">
        <el-button
          size="small"
          @click.native="$emit('reset')"
        >
          Reset
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click.native="apply"
        >
          Apply
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      accounts: [],
      isLoadingAccounts: false,
      carriers: [],
      isLoadingCarriers: false,
      rules: {
        sendTo: [
          { required: true, message: 'Send To is required', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    remoteMethodAccount (query) {
      this.isLoadingAccounts = true
      this.$sdk.account.list(builder => {
        builder.filters = { account_name: query, account_active: 1 }
      }).then(res => {
        this.accounts = res
      }).finally(() => { this.isLoadingAccounts = false })
    },
    remoteMethodCarrier (query) {
      this.isLoadingCarriers = true
      this.$sdk.carrier.list(builder => {
        builder.filters = { 'carrier_name': query }
      }).then(res => {
        this.carriers = res
      }).finally(() => { this.isLoadingCarriers = false })
    },
    apply () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('validated')
        }
      })
    }
  }
}
</script>

<style>

</style>
